import { useAppSelector } from "lib/redux/hooks";
import { selectProgress } from "lib/redux/settingsSlice";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { useEffect, useRef, useState } from "react";

const MobileTotalScore = ({progress}: {progress: number}) => {
  const [isExtended, setIsExtended] = useState(true);
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const isScrollingRef = useRef<boolean>(false); // Flag to detect scrolling

  const handleScroll = () => {
    const scrollElement = scrollContainerRef.current;
    if (scrollElement) {
      const scrollTop = scrollElement.scrollTop;
      const scrollHeight = scrollElement.scrollHeight;
      const clientHeight = scrollElement.clientHeight;

      const reachedTop = scrollTop === 0;
      const reachedBottom = scrollTop + clientHeight >= scrollHeight;

      // If we're at the top or bottom, keep it extended
      if (reachedTop || reachedBottom) {
        setIsExtended(true);
        isScrollingRef.current = false; // Scrolling has stopped at the top or bottom
      } else {
        // If we're scrolling and not at top or bottom, collapse the button
        if (!isScrollingRef.current) {
          setIsExtended(false);
        }
        isScrollingRef.current = true; // We're scrolling
      }
    }
  };

  const handleScrollEnd = () => {
    // Delay checking the scroll state to detect when scrolling stops
    setTimeout(() => {
      isScrollingRef.current = false;
    }, 100); // Adjust this delay to fine-tune the scroll detection
  };

  useEffect(() => {
    const scrollElement = document.querySelector(".progress-scroll");

    if (scrollElement) {
      // Set ref to the scrollable form element
      scrollContainerRef.current = scrollElement as HTMLDivElement;

      // Scroll detection for the form
      scrollElement.addEventListener("scroll", handleScroll);
      scrollElement.addEventListener("scroll", handleScrollEnd);
    }

    // Initially extend the button when the page loads
    setIsExtended(true);

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
        scrollElement.removeEventListener("scroll", handleScrollEnd);
      }
    };
  }, []);

  return (
    <div
      style={{ width: "50px", height: "50px" }}
      className="relative lg:hidden"
    >
      <div
        className={`blue-gradient absolute right-0 flex h-full items-center rounded-[32px] pl-6 font-montserrat font-semibold tracking-wide text-white transition-all duration-500 ${
          isExtended ? "w-40" : "w-0 opacity-0"
        }`}
      >
        Preview
      </div>
      <CircularProgressbarWithChildren
        value={progress}
        styles={buildStyles({
          pathColor: "#84A6FF",
        })}
      >
        <div className="blue-gradient  flex h-12 w-12 flex-col items-center justify-center rounded-full text-white">
          <DocumentTextIcon className="h-auto w-4" />
          <span className="font-montserrat text-[13px] font-semibold">
            {progress}
            {"%"}
          </span>
        </div>
      </CircularProgressbarWithChildren>
    </div>
  );
};

export default MobileTotalScore;
